import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import adrActions from "../../_actions/adrActions";
import { ADR_EDIT } from "../../_constants/actionConstants";
import AdrWorkPerformedTabsV3 from "./AdrWorkPerformedTabsV3";
import AdrLocWorkPerformedV3 from "./AdrLocWorkPerformedV3";
import AddWorkPerformedModalV3 from "./AddWorkPerformedModalV3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AdrWorkPerformedV3 extends Component {
  state = {
    selectedWpTabId: 0,
    showModal_addWp: false,
  };

  componentDidMount() {
    const { dispatch, tabId, workPerformedClient: wpc } = this.props;
    if (wpc) {
      const wpSortOrder = dispatch(adrActions.getWorkPerformedSortOrder(tabId));

      // If Wp's exist, select the first sorted tab by default
      if (wpSortOrder && wpSortOrder.length > 0)
        this.setState({ selectedWpTabId: +wpSortOrder[0].wpTabId });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.workPerformedClient === null &&
      this.props.workPerformedClient !== null
    ) {
      const { dispatch, tabId } = this.props;
      const wpSortOrder = dispatch(adrActions.getWorkPerformedSortOrder(tabId));

      // If Wp's exist, select the first sorted tab by default
      if (wpSortOrder && wpSortOrder.length > 0)
        this.setState({ selectedWpTabId: +wpSortOrder[0].wpTabId });
    } else if (prevProps.loadCount !== this.props.loadCount) {
      // Adr was re-fetched into this tab, so wpTabIds were re-assigned and
      // selectedWpTabId may now point to a different (or nonexistent) Wp. Keep the
      // selection on the tab at the same position as before the re-fetch.
      const { dispatch, tabId } = this.props;
      const wpSortOrder = dispatch(adrActions.getWorkPerformedSortOrder(tabId));
      if (!wpSortOrder || wpSortOrder.length === 0) {
        if (prevState.selectedWpTabId !== 0) this.setState({ selectedWpTabId: 0 });
        return;
      }

      const prevPosition = _.orderBy(
        Object.values(prevProps.workPerformedClient || {}),
        "sortOrder",
        "asc"
      ).findIndex((wp) => wp.wpTabId === prevState.selectedWpTabId);
      const position = Math.min(Math.max(prevPosition, 0), wpSortOrder.length - 1);
      const selectedWpTabId = +wpSortOrder[position].wpTabId;
      if (selectedWpTabId !== this.state.selectedWpTabId)
        this.setState({ selectedWpTabId });
    }
  }

  selectWpTab = (selectedWpTabId) => this.setState({ selectedWpTabId });

  addWp = (newWp) => {
    const { dispatch, tabId, markAdrDirty } = this.props;
    dispatch(adrActions.addWorkPerformed(tabId, newWp)).then((newWpTabId) =>
      this.setState({ selectedWpTabId: newWpTabId })
    );
    markAdrDirty();
  };

  deleteWp = (wpTabId) => {
    const { dispatch, tabId, workPerformedClient: wpc, tentativeAgreements } = this.props;

    // TAs reference the wp by id, so delete them (and their attachments) with it.
    // (The delete confirmation in AdrWorkPerformedTabsV3 warns the user about this.)
    (tentativeAgreements || [])
      .filter((ta) => ta.wpTabId === wpTabId)
      .forEach((ta) => {
        dispatch(
          adrActions.deleteAttachments(
            (ta.attachments || [])
              .map((taa) => [taa.filePath, taa.imageThumbnailFilePath])
              .flat()
          )
        );
        dispatch({
          type: ADR_EDIT.TENTATIVE_AGREEMENTS.DELETE,
          tabId,
          clientId: ta.clientId,
        });
      });

    let filePathsToDelete = [];
    wpc[wpTabId].locationWorkPerformed.forEach((locWp) => {
      if (locWp.attachments.length)
        filePathsToDelete = [
          ...filePathsToDelete,
          ...locWp.attachments
            .map((locWpa) => [locWpa.filePath, locWpa.imageThumbnailFilePath])
            .flat(),
        ];
    });
    dispatch(adrActions.deleteAttachments(filePathsToDelete));

    dispatch(adrActions.deleteWorkPerformed(tabId, wpTabId));
  };

  closeWpTab = (wpTabId) => {
    // Before closing, select wpTab with the next highest sortOrder.
    const { selectedWpTabId } = this.state;
    const { tabId, dispatch, workPerformedClient, markAdrDirty } = this.props;
    const wpSortOrder = dispatch(adrActions.getWorkPerformedSortOrder(tabId));
    const currSortOrder = workPerformedClient[wpTabId].sortOrder;

    // If the tab being closed is not the currently selected tab, keep the
    // current tab selection - there's no need to move the tab focus.
    // But if the currently selected tab is being closed, select the tab
    // with next highest sortOrder.
    // If the wpTab being closed is the last tab, select the second to last.
    const wpTabToSelect =
      wpTabId !== selectedWpTabId
        ? selectedWpTabId
        : currSortOrder === wpSortOrder[wpSortOrder.length - 1].sortOrder
        ? wpSortOrder.length > 1
          ? wpSortOrder[wpSortOrder.length - 2].wpTabId
          : 0
        : wpSortOrder.filter((so) => so.sortOrder > currSortOrder)[0].wpTabId;

    this.deleteWp(wpTabId);
    this.setState({ selectedWpTabId: wpTabToSelect });
    markAdrDirty();
  };

  toggleModal_addWp = () =>
    this.setState({ showModal_addWp: !this.state.showModal_addWp });

  renderDefaultTab = () => {
    return (
      <div
        className="tab-pane show active border border-secondary p-4"
        id="0"
        role="tabpanel"
      >
        <label>
          <em>No item/CCO found in this daily report</em>
        </label>
        <hr className="mt-0 mb-1" />
        <div className="alert alert-info">
          <h5>
            <strong>
              No item or CCO found. Press "
              <FontAwesomeIcon className="fa-sm" icon="plus" />" above to begin.
            </strong>
          </h5>
          <p>
            This daily report is currently not associated with any item or CCO. You may
            add a new item or CCO using '+' button next to the tab header.
            <br />
            You can continue editing this report and save without any items or CCO added.
            <br />
            To enter labor/equipment data, at least one item or CCO must be added to this report.
          </p>
        </div>
      </div>
    );
  };

  render() {
    const {
      projectId,
      tabId,
      workPerformedClient: wpc,
      markAdrDirty,
      fileUploadModal,
      status,
      loadCount,
    } = this.props;
    const { selectedWpTabId, showModal_addWp } = this.state;
    return (
      <React.Fragment>
        <div className="card mb-2 mx-2">
          <div className="card-body">
            <AdrWorkPerformedTabsV3
              tabId={tabId}
              projectId={projectId}
              workPerformedClient={wpc ? (Object.keys(wpc).length > 0 ? wpc : {}) : {}}
              selectedWpTabId={selectedWpTabId}
              selectWpTab={this.selectWpTab}
              closeWpTab={this.closeWpTab}
              toggleModal_addWp={this.toggleModal_addWp}
              status={status}
            />
            <div className="tab-content p-0">
              {wpc
                ? Object.keys(wpc).length > 0
                  ? Object.entries(wpc).map(([wpTabId, wpc]) => (
                      <AdrLocWorkPerformedV3
                        // loadCount in key: re-mount on re-fetch (see AdrMainV3)
                        key={`locWpKey_${loadCount}_${wpTabId}`}
                        projectId={projectId}
                        tabId={tabId}
                        wpTabId={wpc.wpTabId}
                        workPerformedClient={wpc}
                        selectedWpTabId={selectedWpTabId}
                        markAdrDirty={markAdrDirty}
                        fileUploadModal={fileUploadModal}
                        status={status}
                      />
                    ))
                  : this.renderDefaultTab()
                : this.renderDefaultTab()}
            </div>
          </div>
        </div>
        {showModal_addWp && (
          <AddWorkPerformedModalV3
            tabId={tabId}
            projectId={projectId}
            showModal_addWp={showModal_addWp}
            toggleModal_addWp={this.toggleModal_addWp}
            addWp={this.addWp}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  workPerformedClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].workPerformedClient || null
    : null,
  // Increments whenever the Adr is re-fetched into this tab (see AdrMainV3)
  loadCount: (state.adr.loadCounts || {})[ownProps.tabId] || 0,
  tentativeAgreements: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].tentativeAgreements || []
    : [],
});

AdrWorkPerformedV3.propTypes = {
  workPerformedClient: PropTypes.object,
  tabId: PropTypes.number,
  status: PropTypes.object,
  loadCount: PropTypes.number,
};

export default connect(mapStateToProps)(AdrWorkPerformedV3);
